// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"styles_tableContainer__NuM0y"};